import React, { useEffect, useRef } from 'react';
import EmailEditor from 'react-email-editor';
import { changeTheme, revert_button } from '../../assets/images';
import { dsButtonGhostBrand, dsButtonPrimary, dsButtonSecondary, joinButtonClasses } from '../../utils/buttonStyles';

export default function UnlayerEmailEditor({ initialVal, updateValue, saveToDraft, exitEditor, revertToOriginal }) {
  const emailEditorRef = useRef(null);

  useEffect(() => {
    const unlayer = emailEditorRef.current?.editor;
    if (initialVal && emailEditorRef.current && unlayer) {
      unlayer.addEventListener('design:loaded', onDesignLoad);
      unlayer.loadDesign(initialVal);
    }
  }, [initialVal]);

  const onDesignLoad = (data) => {
    console.log('onDesignLoad', data);
  };

  const saveDesign = () => {
    const unlayer = emailEditorRef.current?.editor;

    unlayer?.saveDesign((design) => {
      console.log('saveDesign', design);
      alert('Design JSON has been logged in your developer console.');
    });
  };

  const onLoad = (unlayer) => {
    unlayer.addEventListener('design:loaded', onDesignLoad);
    unlayer.loadDesign(initialVal);
  };

  const onReady = () => {
    console.log('onReady', unlayer);
  };

  const exportToHtml = () => {
    emailEditorRef.current.editor.exportHtml((data) => {
      const { design, html } = data;
      saveToDraft({content: html, template_data: design});
    });
  };

  const updateContent = () => {
    emailEditorRef.current.editor.exportHtml((data) => {
      const { design, html } = data;
      updateValue({content: html, template_data: design});
    });
  }

  const handleUndo = () => {
    emailEditorRef.current?.editor.undo();
  };
  
  const handleRedo = () => {
    emailEditorRef.current?.editor.redo();
  };

  return (
    <div className='bg-white'>
      <div className='flex justify-between mr-6'>
        <img src={changeTheme} className='mx-6 my-3' style={{width: 45, height: 45}}/>
        <button onClick={() => revertToOriginal()} name='revert' className={joinButtonClasses(dsButtonGhostBrand, 'm-4 h-11 px-4')}>
          <img src={revert_button} className='mr-2'/>
          <div>Revert to original</div>
        </button>
      </div>
      <div className="flex items-center -mb-2 gap-4 px-4 py-2 bg-white rounded-md shadow-sm w-fit">
        <button
          onClick={handleUndo}
          className={joinButtonClasses(dsButtonSecondary, 'h-9 px-4')}
        >
          ↺ Undo
        </button>
        <button
          onClick={handleRedo}
          className={joinButtonClasses(dsButtonSecondary, 'h-9 px-4')}
        >
          ↻ Redo
        </button>
      </div>
      <div className='#F5F7F9'>
      <EmailEditor
          ref={emailEditorRef}
          style={{ height: 'calc(100vh - 150px)' }}
          onLoad={onLoad}
          onReady={onReady}

          options={{
            features: {
              undoRedo: true
            },
            projectId: 272692,
            tools: {
              features: {
                undoRedo: true,
                blocks: {
                  hideOnMobile: true,
                  hideOnDesktop: true
                }
              },
              social: {
                properties: {
                  icons: {
                    value: {
                      editor: {
                        data: {
                          customIcons: [
                            {
                              name: 'AppStore',
                              url: 'https://apps.apple.com/in/app/ekincare/id973037249',
                              width: 120,
                              height: 40,
                              icons: {
                                circle: 'https://res.cloudinary.com/ekincare/image/upload/v1592891851/mailers/app_store.png',
                                'circle-black': 'https://res.cloudinary.com/ekincare/image/upload/v1592891851/mailers/app_store.png',
                                'circle-white': 'https://res.cloudinary.com/ekincare/image/upload/v1592891851/mailers/app_store.png',
                                rounded: 'https://res.cloudinary.com/ekincare/image/upload/v1592891851/mailers/app_store.png',
                                'rounded-black': 'https://res.cloudinary.com/ekincare/image/upload/v1592891851/mailers/app_store.png',
                                squared: 'https://res.cloudinary.com/ekincare/image/upload/v1592891851/mailers/app_store.png',
                                'squared-black': 'https://res.cloudinary.com/ekincare/image/upload/v1592891851/mailers/app_store.png',
                              },
                            },
                            {
                              name: 'PlayStore',
                              url: 'https://play.google.com/store/apps/details?id=com.ekincare&amp;hl=en_IN&amp;gl=US',
                              width: 120,
                              height: 40,
                              icons: {
                                circle: 'https://res.cloudinary.com/ekincare/image/upload/v1592891852/mailers/google_play.png',
                                'circle-black': 'https://res.cloudinary.com/ekincare/image/upload/v1592891852/mailers/google_play.png',
                                'circle-white': 'https://res.cloudinary.com/ekincare/image/upload/v1592891852/mailers/google_play.png',
                                rounded: 'https://res.cloudinary.com/ekincare/image/upload/v1592891852/mailers/google_play.png',
                                'rounded-black': 'https://res.cloudinary.com/ekincare/image/upload/v1592891852/mailers/google_play.png',
                                squared: 'https://res.cloudinary.com/ekincare/image/upload/v1592891852/mailers/google_play.png',
                                'squared-black': 'https://res.cloudinary.com/ekincare/image/upload/v1592891852/mailers/google_play.png',
                              }
                            }
                          ]
                        }
                      }
                    }
                  }
                }
              }
            }
          }}
          

          editorProps={{
            customImageHandler: (file, done) => {
              const formData = new FormData();
              formData.append("file", file);
        
              fetch(`${window.API_URL}/corporate/company_mailer_image`, {
                method: "POST",
                body: formData,
              })
                .then((res) => res.json())
                .then((data) => {
                  // Cloudinary URL or your API’s response
                  done({ url: data.secure_url || data.image_url });
                })
                .catch((err) => {
                  console.error("Image upload failed:", err);
                  done(); // fallback to default
                });
            }
          }}
        />
      </div>
      <div className='fixed z-10 right-0 w-full bg-white py-2 pt-4 px-12 flex justify-end bottom-4'>
        {/* <button onClick={saveDesign}>Save Design</button> */}
        <button onClick ={exitEditor} name='exit' className={joinButtonClasses(dsButtonSecondary, 'h-11 px-6')}>Exit editor</button>
        <button onClick={updateContent} name='preview' className={joinButtonClasses(dsButtonSecondary, 'mx-4 h-11 px-6')}>Preview & test</button>
        <button name='continue' onClick ={exportToHtml} className={joinButtonClasses(dsButtonPrimary, 'h-11 px-6')}>Save changes</button>
      </div>
    </div>
  );
}
